import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from 'stylesheets/components/placeholders/book_card_placeholder.module';

export function BookCardPlaceholder(props) {
  return (
    <div className={styles.bookCardPlaceholder} data-testid='book-card-placeholder'>
      <div className={styles.coverPlaceholder}>
        <div className={styles.coverImage}></div>
      </div>
      <div className={styles.titlePlaceholder}></div>
      <div className={styles.authorPlaceholder}></div>
      {props.showStarRating && (
        <div
          className={classNames(styles.starRatingPlaceholder, { [styles.short]: props.useSmallTextPlaceholders })}
        ></div>
      )}
      <div className={classNames(styles.pricingPlaceholder, { [styles.short]: props.useSmallTextPlaceholders })}></div>
      {props.showTimeLeftPlaceholder && (
        <div
          className={classNames(styles.daysLeftTextPlaceholder, { [styles.short]: props.useSmallTextPlaceholders })}
        ></div>
      )}
    </div>
  );
}

BookCardPlaceholder.propTypes = {
  useSmallTextPlaceholders: PropTypes.bool,
  showStarRating: PropTypes.bool,
  showTimeLeftPlaceholder: PropTypes.bool,
};

BookCardPlaceholder.defaultProps = {
  useSmallTextPlaceholders: false,
  showStarRating: false,
  showTimeLeftPlaceholder: true,
};
